import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { B2bLivreBlancComponent } from './b2b-livre-blanc.component';
import { B2bLivreBlancDetailsComponent } from './b2b-livre-blanc-details/b2b-livre-blanc-details.component';
import { B2bLivreBlancBreadcrumbsResolver } from './b2b-livre-blanc-breadcrumbs.resolver';
import { B2bTunnelShellComponent } from '../b2b-tunnel-shell/b2b-tunnel-shell.component';
import { B2bDownloadConfirmationComponent } from '../b2b-download-confirmation/b2b-download-confirmation.component';

const routes: Routes = [
  {
    path: '',
    component: B2bLivreBlancComponent,
    data: {
      title: `Concilio, la plateforme d'accompagnement santé`,
      description: 'Livre blanc',
      keywords: 'b2b, concilio',
      breadcrumbs: 'Nos livres blancs',
    },
  },
  {
    path: ':id',
    component: B2bLivreBlancDetailsComponent,
    data: {
      title: `Concilio, la plateforme d'accompagnement santé`,
      description: 'Livre blanc',
      keywords: 'b2b, concilio',
      breadcrumbs: B2bLivreBlancBreadcrumbsResolver,
    },
  },
  {
    path: ':id/confirmation',
    component: B2bTunnelShellComponent,
    data: {
      title: `Concilio, la plateforme d'accompagnement santé`,
      description: 'Livre blanc',
      keywords: 'b2b, concilio',
      breadcrumbs: B2bLivreBlancBreadcrumbsResolver,
    },
    children: [
      {
        path: '',
        component: B2bDownloadConfirmationComponent,
        data: {
          title: `Concilio, la plateforme d'accompagnement santé`,
          description: 'Livre blanc',
          keywords: 'b2b, concilio',
          breadcrumbs: 'Confirmation',
        },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class B2bLivreBlancRoutingModule {}
